const validateString = (searchString, regexPattern, type) => {
  // Check if input is defined and is a string
  if (!searchString || typeof searchString !== 'string') {
    return {
      isValid: false,
      message: `${type} Search string must be a valid string`,
    };
  }

  // Check if string is numbers only - allow any length
  const isNumericOnly = /^\d+$/.test(searchString);
  if (isNumericOnly) {
    return {
      isValid: true,
      message: 'Valid numeric search string',
    };
  }

  // For non-numeric strings, check minimum length requirement
  if (searchString.length <= 3) {
    return {
      isValid: false,
      message: `${type} Search string with letters must be longer than 3 characters`,
    };
  }
  if (regexPattern.test(searchString)) {
    return {
      isValid: true,
      message: 'Valid search string',
    };
  }

  return {
    isValid: false,
    message: `${type} Search string must be either numbers only or contain letters with hyphen and end with a number`,
  };
};
export default validateString;
